import { TTabs } from '@/src/types/Tab';
import PropTypes from 'prop-types';
import { createContext, useMemo, useState } from 'react';

interface IAppContext {
  user?: any;
  shared?: any;
  banner?: any;
  bannerFood?: any;
  promotion?: any;
  location?: any;
  quickCommerce?: any;
  food?: any;
  origin?: string;
  expandedList?: string;
  isBottomNav?: boolean | string;
  headers?: any;
  passport?: any;
  env?: string;
  activeTab?: TTabs;

  setActiveTab?: (value: TTabs) => void;
  home?: any;
  isRevamp?: boolean;
}

export const AppContext = createContext<IAppContext>({
  user: [],
  shared: [],
  banner: [],
  bannerFood: [],
  promotion: [],
  location: [],
  quickCommerce: [],
  food: [],
  origin: '',
  expandedList: 'false',
  isBottomNav: false,
  headers: [],
  passport: [],
  env: '',
  activeTab: 'promotions',
  setActiveTab: () => {},
  home: [],
  isRevamp: false,
});

/**
 * Provider for the current App to store the initial response from SSR
 * @param {object} params
 */
const AppProvider = ({ children, initialState }) => {
  const [activeTab, setActiveTab] = useState('');

  const appContextValue = useMemo(
    () => ({ ...initialState, activeTab, setActiveTab }),
    [initialState, activeTab],
  );

  return (
    <AppContext.Provider value={appContextValue}>
      {children}
    </AppContext.Provider>
  );
};

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppProvider;
